import React from 'react';
import Box from '@mui/material/Box';
import { QRCode } from 'react-qrcode-logo';

export interface QrCodeProps {
  value: string;
  size?: number;
  bgColor?: string;
  fgColor?: string;
  darkMode?: boolean;
  /**
   * The logo is punched out of the code's own error-correction budget, so a QR that has to
   * survive a poor camera at an angle can drop it. Branding is the default; legibility is opt-in
   * because only the caller knows which matters more on its screen.
   */
  showLogo?: boolean;
}

export const QrCodeOutput: React.FC<QrCodeProps> = ({
  value,
  size = 256,
  bgColor = '#FFF',
  fgColor = '#000',
  darkMode = false,
  showLogo = true,
}) => {
  const logo = darkMode ? '/assets/idu-logo-dark.svg' : '/assets/idu-logo-light.svg';
  const logoProps = showLogo
    ? {
        logoImage: logo,
        logoPadding: 2,
        logoWidth: size / 4,
        logoHeight: size / 7,
        logoPaddingRadius: 4,
        removeQrCodeBehindLogo: true,
      }
    : {};

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        background: bgColor,
        borderRadius: 2,
        boxShadow: 1,
        p: 2,
        maxWidth: '100%',
        flexDirection: 'column',
      }}
    >
      <QRCode
        style={{
          maxWidth: '100%',
          height: 'auto',
          aspectRatio: '1 / 1',
        }}
        id="qr-code"
        value={value}
        size={size}
        bgColor={bgColor}
        fgColor={fgColor}
        aria-label="QR code"
        {...logoProps}
      />
    </Box>
  );
};
